import React, { useState } from "react";
import { Card, CardContent, Typography, Avatar, IconButton, Tooltip, Snackbar, Alert } from "@mui/material";
import { Replay, Download } from "@mui/icons-material";
import DeleteIcon from '@mui/icons-material/Delete';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import axios from "axios";

const UserCard = ({ name, date, onClick, discarded, evaluate, id, onStatusUpdate, image }) => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const deleteCandidate = async (id) => {
    if (!window.confirm("Are you sure you want to delete this candidate?")) return;

    try {
      await axios.post('https://api.a2ajobs.com/api/candidate-delete', {
        candidate_id: id
      });
      alert("Candidate deleted successfully!");
      if (onStatusUpdate) {
        onStatusUpdate("deleted");
      }
    } catch (error) {
      console.error("Error deleting candidate:", error.response?.data || error.message);
      alert("Failed to delete candidate!");
    }
  };

  const updateCandidateStatus = async (newStatus) => {
    try {
      const response = await axios.post("https://api.a2ajobs.com/api/candidate-update", {
        candidate_id: id,
        status: newStatus
      });

      if (response.status === 200) {
        setSnackbarMessage("Candidate updated successfully!");
        setSnackbarOpen(true);

        // Call the callback function to refresh the candidate list
        if (onStatusUpdate) {
          onStatusUpdate(newStatus);
        }
      } else {
        console.error("Failed to update candidate");
      }
    } catch (error) {
      console.error("Error updating candidate:", error);
      setSnackbarMessage("Failed to update candidate.");
      setSnackbarOpen(true);
    }
  };

  const cleanUrl = (url) => {
    if (!url) return null;
    return url.replace(/\\/g, '');
  };

  return (
    <Card sx={{ display: "flex", alignItems: "center", p: { xs: 0, md: 2 }, mb: 2, "&:hover": { cursor: 'pointer' } }} onClick={onClick}>
      <Avatar
        sx={{ width: 50, height: 50, mr: 2, fontSize: 12, color: 'gray' }}
        src={cleanUrl(image)}
      >
        {!image && name?.charAt(0)}
      </Avatar>
      <CardContent sx={{ flexGrow: 1 }}>
        <Typography variant="h6" fontWeight={700}>{name}</Typography>
        <Typography fontSize={{ md: 17, xs: 10 }} color="textSecondary">Completed on {date}</Typography>
      </CardContent>
      <Tooltip title={evaluate ? "shortlisted" : "Move back to"}>
        <IconButton color="error">
          {evaluate ? <WorkspacePremiumIcon onClick={(e) => {
            e.stopPropagation();
            updateCandidateStatus("shortlisted");
          }} /> : <Replay onClick={(e) => {
            e.stopPropagation();
            updateCandidateStatus("evaluate");
          }} />}
        </IconButton>
      </Tooltip>
      <Tooltip title={discarded ? "Delete" : "Discarded"}>
        <IconButton color="primary">
          {discarded ? <DeleteIcon onClick={() => deleteCandidate(id)} /> : <Download onClick={(e) => {
            e.stopPropagation();
            updateCandidateStatus("discarded");
          }} />}
        </IconButton>
      </Tooltip>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={() => setSnackbarOpen(false)} severity="success" sx={{ width: "100%" }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Card>
  );
};

export default UserCard;